import React, { useEffect, useState } from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Lock } from "lucide-react";

export default function PrivateCollection() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const invite = sp.get("invite");
  const [data, setData] = useState(null);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    const run = async () => {
      if (invite) {
        try { await api.post(`/private/redeem/${invite}`); }
        catch (e) { console.debug("invite redeem failed; checking existing access", e); }
      }
      try { const r = await api.get(`/sellers/${id}/private`); setData(r.data); }
      catch (e) { console.debug("no private access", e); setDenied(true); }
    };
    run();
  }, [id, invite]);

  if (denied) {
    return (
      <div className="max-w-3xl mx-auto px-5 py-24 text-center" data-testid="private-denied">
        <Lock size={22} className="mx-auto" style={{ color: "#1E3A2B" }} />
        <h1 className="font-display text-3xl mt-3">This collection is private.</h1>
        <p className="mt-2 text-sm text-neutral-500">
          Ask the seller for access from their closet, or wait for an invite.
        </p>
        <Link to={`/seller/${id}`} className="btn-primary inline-flex mt-6" data-testid="back-to-seller">Back to closet</Link>
      </div>
    );
  }
  if (!data) return <div className="p-16 text-center label-eyebrow" data-testid="private-loading">Loading…</div>;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-10" data-testid="private-collection-page">
      <div className="hairline-b pb-6">
        <div className="flex items-center gap-2" style={{ color: "#1E3A2B" }}>
          <Lock size={15} /> <span className="label-eyebrow">Private collection</span>
        </div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tighter mt-2" data-testid="private-seller-name">
          {data.seller_name}'s private closet
        </h1>
        <p className="mt-2 text-sm text-neutral-500">Visible only to approved shoppers. Checkout works as normal.</p>
      </div>
      {data.items.length === 0 ? (
        <div className="hairline p-14 text-center mt-8 text-sm text-neutral-500" data-testid="private-empty">
          No private items right now — check back soon.
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-8" data-testid="private-listings">
          {data.items.map((it) => <ProductCard key={it.id} item={it} testid={`private-item-${it.id}`} />)}
        </div>
      )}
    </div>
  );
}
